
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {fetchReport} from 'redux/modules/reports/actions'
import {getReport} from 'redux/modules/reports/selectors'
import TrafficReport from 'components/TrafficReport'

export class ReportView extends React.Component {
  static propTypes = {
    fetchReport: PropTypes.func,
    id: PropTypes.string,
    metrics: PropTypes.array,
    dimensions: PropTypes.array,
    filter: PropTypes.array,
    data: PropTypes.array,
    total: PropTypes.object,
    charts: PropTypes.array,
    sites: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    crossSiteMode: PropTypes.bool
  }

  static contextTypes = {
    currency: PropTypes.string,
    timezone: PropTypes.string
  }

  componentDidMount() {
    const {fetchReport, id, crossSiteMode} = this.props
    const {currency, timezone} = this.context

    fetchReport(id, crossSiteMode, currency, timezone)
  }

  render() {
    const {metrics, dimensions, filter, data, total, charts, sites} = this.props

    return (
      <div className='report-view'>
        <TrafficReport
          data={data}
          total={total}
          metrics={metrics}
          dimensions={dimensions}
          filter={filter}
          charts={charts}
          sites={sites}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const {reportId: id} = props.params

  return {
    sites: state.sites.list,
    id,
    crossSiteMode: props.route.crossSiteMode,
    ...getReport(state, id)
  }
}

const mapDispatchToProps = {
  fetchReport
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportView)
export {default as ReportViewMenu} from './Menu'



// WEBPACK FOOTER //
// ./client/views/ReportView/index.js